<template>
  <ul class="nav">
    <router-link :to="item.path" tag="li" v-for="(item, index) in routers" data-io-click="tracker" :key="index">{{ item.name }}</router-link>
  </ul>
</template>

<script>
export default {
  props: {
    routers: {
      type: Array
    }
  }
}
</script>

<style scoped>
li {
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #fff;
  font-size: 14px;
  cursor: pointer;
}

li.actived {
  background: #2877ff;
  color: #fff;
}
</style>

